import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import ListBoards from '../../Containers/ListBoards';
import Icons from '../../Containers/Icons';

class Tableros extends Component {
  constructor(){
    super();
    this.state = {
      read: false
    }
  }

  componentDidMount(){
    if (this.props.tab === false) {
      this.props.db("tableros-home");
    }
  }


  render () {
    let {tab, lang, langtxt} = this.props;
    return(
    <div id="tableros">
      <ul>
      {(tab !== undefined) && (tab !== false)
      ? Object.keys(tab).map((key) => {
        let tablero = tab[key][0];
        let visual = tab[key][1];
          return (
            <NavLink 
              to={`/home/show/${tablero.id}`} 
              key={tablero.id} 
              onClick={() => this.props.selectTablero(visual, tablero)}>
            <ListBoards 
            key={tablero.id} 
            tabs={tablero} 
            vis={visual}
            />
            </NavLink>
          )
        })
      : <span className="loading"><Icons name="load" /><p>{langtxt.home.Cargando[lang]}</p></span>
      }
      </ul>
    </div>
  )
  }
}
export default Tableros;


// WEBPACK FOOTER //
// ./src/Components/Boards/Tableros.js